/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import {
  BUILDING_SQUARE_FOOTAGE,
  FIRST_STORY_FULL_WALL_RATIO_DIR_1,
  FIRST_STORY_FULL_WALL_RATIO_DIR_2,
  FIRST_STORY_INFILLED_WALL_RATIO_DIR_1,
  FIRST_STORY_INFILLED_WALL_RATIO_DIR_2,
  NUMBER_OF_STORIES,
  TDMF_BAY_LENGTH_DIR_1,
  TDMF_BAY_LENGTH_DIR_2,
  TDMF_DAMPER_CONFIG_DIR_1,
  TDMF_DAMPER_CONFIG_DIR_2,
  TDMF_DAMPER_EXPOSURE_DIR_1,
  TDMF_DAMPER_EXPOSURE_DIR_2,
  REPAIR_COSTS_SCALE_WITH_BUILDING_VALUE,
  UPPER_STORY_FULL_WALL_RATIO_DIR_1,
  UPPER_STORY_FULL_WALL_RATIO_DIR_2,
  UPPER_STORY_HEIGHT,
  UPPER_STORY_INFILLED_WALL_RATIO_DIR_1,
  UPPER_STORY_INFILLED_WALL_RATIO_DIR_2,
  YLBF_BAY_LENGTH_DIR_1,
  YLBF_BAY_LENGTH_DIR_2,
  YLBF_BRACE_CONFIG_DIR_1,
  YLBF_BRACE_CONFIG_DIR_2,
  YLBF_BRACE_EXPOSURE_DIR_1,
  YLBF_BRACE_EXPOSURE_DIR_2,
  YLBF_NUM_FUSES_PER_BRACE_DIR_1,
  YLBF_NUM_FUSES_PER_BRACE_DIR_2,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import BuildingLayoutSection from './BuildingLayoutSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { selectFormFieldVisibility, selectFormValues } = modelTypesByForm[ownProps.form];
  return {
    showRepairCostsScaleWithBuildingValue: selectFormFieldVisibility(state)(
      REPAIR_COSTS_SCALE_WITH_BUILDING_VALUE
    ),
    showFirstStoryFullWallRatioDir1: selectFormFieldVisibility(state)(
      FIRST_STORY_FULL_WALL_RATIO_DIR_1
    ),
    showFirstStoryFullWallRatioDir2: selectFormFieldVisibility(state)(
      FIRST_STORY_FULL_WALL_RATIO_DIR_2
    ),
    showFirstStoryInfilledWallRatioDir1: selectFormFieldVisibility(state)(
      FIRST_STORY_INFILLED_WALL_RATIO_DIR_1
    ),
    showFirstStoryInfilledWallRatioDir2: selectFormFieldVisibility(state)(
      FIRST_STORY_INFILLED_WALL_RATIO_DIR_2
    ),
    showUpperStoryFullWallRatioDir1: selectFormFieldVisibility(state)(
      UPPER_STORY_FULL_WALL_RATIO_DIR_1
    ),
    showUpperStoryFullWallRatioDir2: selectFormFieldVisibility(state)(
      UPPER_STORY_FULL_WALL_RATIO_DIR_2
    ),
    showUpperStoryInfilledWallRatioDir1: selectFormFieldVisibility(state)(
      UPPER_STORY_INFILLED_WALL_RATIO_DIR_1
    ),
    showUpperStoryInfilledWallRatioDir2: selectFormFieldVisibility(state)(
      UPPER_STORY_INFILLED_WALL_RATIO_DIR_2
    ),
    showUpperStoryHeight: selectFormFieldVisibility(state)(UPPER_STORY_HEIGHT),
    showYlbfBayLengthDir1: selectFormFieldVisibility(state)(YLBF_BAY_LENGTH_DIR_1),
    showYlbfBayLengthDir2: selectFormFieldVisibility(state)(YLBF_BAY_LENGTH_DIR_2),
    showYlbfBraceConfigDir1: selectFormFieldVisibility(state)(YLBF_BRACE_CONFIG_DIR_1),
    showYlbfBraceConfigDir2: selectFormFieldVisibility(state)(YLBF_BRACE_CONFIG_DIR_2),
    showYlbfBraceExposureDir1: selectFormFieldVisibility(state)(YLBF_BRACE_EXPOSURE_DIR_1),
    showYlbfBraceExposureDir2: selectFormFieldVisibility(state)(YLBF_BRACE_EXPOSURE_DIR_2),
    showYlbfNumFusesPerBraceDir1: selectFormFieldVisibility(state)(YLBF_NUM_FUSES_PER_BRACE_DIR_1),
    showYlbfNumFusesPerBraceDir2: selectFormFieldVisibility(state)(YLBF_NUM_FUSES_PER_BRACE_DIR_2),
    showTdmfDamperConfigDir1: selectFormFieldVisibility(state)(TDMF_DAMPER_CONFIG_DIR_1),
    showTdmfBayLengthDir1: selectFormFieldVisibility(state)(TDMF_BAY_LENGTH_DIR_1),
    showTdmfDamperExposureDir1: selectFormFieldVisibility(state)(TDMF_DAMPER_EXPOSURE_DIR_1),
    showTdmfDamperConfigDir2: selectFormFieldVisibility(state)(TDMF_DAMPER_CONFIG_DIR_2),
    showTdmfBayLengthDir2: selectFormFieldVisibility(state)(TDMF_BAY_LENGTH_DIR_2),
    showTdmfDamperExposureDir2: selectFormFieldVisibility(state)(TDMF_DAMPER_EXPOSURE_DIR_2),
    isTwoStories: selectFormValues(state, NUMBER_OF_STORIES) === '2',
    defineFloorPlanByStory: !selectFormFieldVisibility(state)(BUILDING_SQUARE_FOOTAGE),
  };
};

export default connect(mapStateToProps)(BuildingLayoutSection);
